"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserByUserName = void 0;
var server_1 = require("../../helpers/server");
var _ = require("lodash");
var redux_persist_1 = require("redux-persist");
var UserActions_1 = require("./UserActions");
// Initial state values
var initialState = {
    identity: null,
    users: [],
    total: 0,
    companies: {},
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        /* -------------  USERS API  ------------------- */
        case (0, server_1.apiActions)(UserActions_1.UserActions.GET_USERS).success:
            var users = action.payload.page > 0 ? __spreadArray(__spreadArray([], state.users, true), action.payload.results, true) :
                action.payload.results;
            return __assign(__assign({}, state), { users: users, total: action.payload.total });
        /* -------------  END USERS API  ------------------- */
        /* -------------  COMPANIES API  ------------------- */
        case (0, server_1.apiActions)(UserActions_1.UserActions.COMPANIES_API).success:
            return __assign(__assign({}, state), { companies: _.keyBy(action.payload, function (c) { return c._id; }) });
        /* -------------  END COMPANIES API  ------------------- */
        /* -------------  SAVE USER API  ------------------- */
        // Case of NEW USER, added to the array in first position,
        // after order will take care of hime
        case (0, server_1.apiActions)(UserActions_1.UserActions.UPDATE_API).success:
            var userList = state.users;
            userList.unshift(action.payload);
            return __assign(__assign({}, state), { users: userList });
        // CASE of UPDATED user, we find him in the array and also update the local one
        case (0, server_1.apiActions)(UserActions_1.UserActions.UPDATE_API, 'PUT').success:
            var stateUsers = state.users;
            var index = _.findIndex(stateUsers, function (user) { return user._id === action.payload._id; });
            stateUsers[index] = __assign(__assign({}, stateUsers[index]), action.payload);
            return __assign(__assign({}, state), { users: stateUsers });
        /* -------------  END SAVE USER API  ------------------- */
        /* ------------- CLEAR USERS  ------------------- */
        case UserActions_1.UserActions.CLEAR_USERS:
            return __assign(__assign({}, state), { users: [] });
        /* ------------- END CLEAR USERS  ------------------- */
        /* ------------- LOGOUT  ------------------- */
        case redux_persist_1.PURGE:
            return __assign({}, initialState);
        /* ------------- END  LOGOUT  ------------------- */
        default:
            return state;
    }
});
var getUserByUserName = function (state, username) {
    return state.users.find(function (u) { return u.username === username; });
};
exports.getUserByUserName = getUserByUserName;
